<template>
  <ul class="v1-itineraryDomesticFlights__list">
    <li class="v1-itineraryDomesticFlights__item" v-for="n in number" :key="itinerary[n]">
      <template v-if="itinerary['domestic' + n + 'DepartureCity']">
        <div class="v1-itineraryDomesticFlights__flight">
          <span
            class="v1-itineraryDomesticFlights__flightFrom"
            v-html="itinerary['domestic' + n + 'DepartureCity']"
          ></span>
          <svg
            role="img"
            viewBox="0 0 25.714 24"
            :aria-labelledby="'label__recommendationGet-airplane' + n"
            class="v1-itineraryGet__icon"
          >
            <desc :id="'label__recommendationGet-airplane' + n">{{ itinerary.to }}</desc>
            <use xlink:href="/japan-travel-planner/common/svg/sprite.svg#flight"></use>
          </svg>
          <span class="v1-itineraryDomesticFlights__flightTo">
            <span v-html="itinerary['domestic' + n + 'ArrivalCity']"></span>
            <small
              class="v1-itineraryDomesticFlights__flightToSmall"
              v-if="itinerary['domestic' + n + 'TransitPoint']"
              v-html="
                itinerary.beforeVia +
                  ' ' +
                  itinerary['domestic' + n + 'TransitPoint'] +
                  ' ' +
                  itinerary.afterVia
              "
            ></small>
          </span>
        </div>
        <div
          class="v1-itineraryDomesticFlights__detail"
          v-if="itinerary['domestic' + n + 'ArrivalCity']"
        >
          <ul class="v1-itineraryDomesticFlights__detailList">
            <li
              class="v1-itineraryDomesticFlights__detailItem"
              v-if="itinerary['domestic' + n + 'FirstSectorDeparture']"
            >
              <span class="v1-itineraryDomesticFlights__detailSammary">
                <span v-html="itinerary['domestic' + n + 'FirstSectorDeparture']"></span>
                <svg
                  role="img"
                  :aria-labelledby="'label__recommendationGet-airplane' + n"
                  class="v1-itineraryDomesticFlights__detailArrow"
                  v-if="itinerary['domestic' + n + 'FirstSectorDeparture']"
                >
                  <desc :id="'label__recommendationGet-airplane' + n">{{ itinerary.to }}</desc>
                  <use
                    xlink:href="/japan-travel-planner/common/svg/sprite.svg#arrow-to-right"
                  ></use>
                </svg>
                <span v-html="itinerary['domestic' + n + 'FirstSectorArrival']"></span>
              </span>
              <span class="v1-itineraryDomesticFlights__detailFlight">
                {{ itinerary.beforeNumberOfFlights ? itinerary.beforeNumberOfFlights : '' }}
                <strong class="v1-itineraryDomesticFlights__detailFlightStrong">
                  {{ itinerary['domestic' + n + 'FirstSectorFlightNum'] }}</strong
                >
                {{
                  itinerary['domestic' + n + 'FirstSectorFlightNum'] >= 2
                    ? itinerary.domesticAfterNumberOfFlightsPluralForm
                    : itinerary.domesticAfterNumberOfFlights
                }}
              </span>
            </li>
            <li
              class="v1-itineraryDomesticFlights__detailItem"
              v-if="itinerary['domestic' + n + 'SecondSectorArrival']"
            >
              <span class="v1-itineraryDomesticFlights__detailSammary">
                <span v-html="itinerary['domestic' + n + 'SecondSectorDeparture']"></span>
                <svg
                  role="img"
                  :aria-labelledby="'label__recommendationGet-airplane' + n"
                  class="v1-itineraryDomesticFlights__detailArrow"
                  v-if="itinerary['domestic' + n + 'FirstSectorDeparture']"
                >
                  <desc :id="'label__recommendationGet-airplane' + n">{{ itinerary.to }}</desc>
                  <use
                    xlink:href="/japan-travel-planner/common/svg/sprite.svg#arrow-to-right"
                  ></use>
                </svg>
                <span v-html="itinerary['domestic' + n + 'SecondSectorArrival']"></span>
              </span>
              <span class="v1-itineraryDomesticFlights__detailFlight">
                {{ itinerary.beforeNumberOfFlights ? itinerary.beforeNumberOfFlights : '' }}
                <strong class="v1-itineraryDomesticFlights__detailFlightStrong">
                  {{ itinerary['domestic' + n + 'SecondSectorFlightNum'] }}</strong
                >
                {{
                  itinerary['domestic' + n + 'SecondSectorFlightNum'] >= 2
                    ? itinerary.domesticAfterNumberOfFlightsPluralForm
                    : itinerary.domesticAfterNumberOfFlights
                }}
              </span>
            </li>
            <li
              class="v1-itineraryDomesticFlights__detailItem"
              v-if="
                !itinerary['domestic' + n + 'FirstSectorDeparture'] &&
                  !itinerary['domestic' + n + 'SecondSectorDeparture']
              "
            >
              <span class="v1-itineraryDomesticFlights__detailSammary"></span>
              <span class="v1-itineraryDomesticFlights__detailFlight">
                {{ itinerary.beforeNumberOfFlights ? itinerary.beforeNumberOfFlights : '' }}
                <strong class="v1-itineraryDomesticFlights__detailFlightStrong">
                  {{ itinerary['domestic' + n + 'DirectFlightsNum'] }}</strong
                >
                {{
                  itinerary['domestic' + n + 'DirectFlightsNum'] >= 2
                    ? itinerary.domesticAfterNumberOfFlightsPluralForm
                    : itinerary.domesticAfterNumberOfFlights
                }}
              </span>
            </li>
          </ul>
          <form
            method="get"
            action="https://aswbe-i.ana.co.jp/international_asw/pages/revenue/search/roundtrip/search_roundtrip_input.xhtml"
            class="v1-itineraryDomesticFlights__linkarea"
            v-if="!isIrregularParameters()"
          >
            <input type="hidden" name="CONNECTION_KIND" :value="itinerary.connectionKind" />
            <input type="hidden" name="LANG" :value="bookingEngineLang" />
            <input type="hidden" name="hiddenSearchMode" value="ROUND_TRIP" />
            <input
              type="hidden"
              name="departureAirportCode:field"
              :value="itinerary['domestic' + n + 'DepartureAirportCode']"
            />
            <input
              type="hidden"
              name="arrivalAirportCode:field"
              :value="itinerary['domestic' + n + 'ArrivalAirportCode']"
            />
            <input type="hidden" name="adultCount" value="1" />
            <input type="hidden" name="boardingClass" value="ECO" />
            <input type="hidden" name="searchFlag" value="0" />
            <input type="hidden" name="STATIC" value="STATIC" />
            <button type="submit" class="v1-itineraryDomesticFlights__link">
              {{ itinerary.cta }}
            </button>
          </form>
          <form
            method="get"
            action="https://aswbe-d.ana.co.jp/9Eile48/dms/redbe/dyc/be/pages/res/search/vacantEntranceDispatch.xhtml"
            class="v1-itineraryDomesticFlights__linkarea"
            v-if="isIrregularParameters()"
          >
            <input type="hidden" name="LANG" :value="bookingEngineLang" />
            <input type="hidden" name="roundFlag" value="1" />
            <input
              type="hidden"
              name="departureAirport"
              :value="itinerary['domestic' + n + 'DepartureAirportCode']"
            />
            <input
              type="hidden"
              name="arrivalAirport"
              :value="itinerary['domestic' + n + 'ArrivalAirportCode']"
            />
            <input type="hidden" name="adultCount" value="1" />
            <input type="hidden" name="compartmentClass" value="Y" />
            <input type="hidden" name="STATIC" value="STATIC" />
            <button type="submit" class="v1-itineraryDomesticFlights__link">
              {{ itinerary.cta }}
            </button>
          </form>
        </div>
      </template>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'v1FlightInfomationDomesticFrights',
  props: {
    itinerary: {
      type: Object,
      required: true,
    },
    number: {
      type: Number,
      required: true,
    },
    pageLang: {
      type: String,
      required: true,
    },
    pageCountry: {
      type: String,
      required: true,
    },
  },
  computed: {
    bookingEngineLang() {
      const isZh = this.pageLang === 'zh';

      if (isZh) {
        return this.itinerary.countryCode;
      }

      return this.itinerary.langCode;
    },
  },
  methods: {
    // `en/jp`と`ja/jp`は正常に動作していないため、一時的にパラメーターを変更
    // ANA_KAN_A-387
    isIrregularParameters() {
      const isIrregular = !!(
        (this.pageLang === 'en' && this.pageCountry === 'jp') ||
        (this.pageLang === 'ja' && this.pageCountry === 'jp')
      );
      return isIrregular;
    },
  },
};
</script>
